import {Syndicates} from "modules/utils/enums";

export const MAIN_COLOUR = process.env.REACT_APP_MAIN_COLOUR || "#1B48E0";
export const LADDER_HEADING_COLOUR =
	process.env.REACT_APP_LADDER_HEADER_COLOUR || "#000";
export const SPONSOR_LEAGUE_COLOUR =
	process.env.REACT_APP_SPONSOR_LEAGUE_COLOUR || "#000";
export const HOME_ACTION_BUTTON_BG =
	process.env.REACT_APP_HOME_ACTION_BUTTON_BG || "#000";

export const HOME_ACTION_BUTTON_COLOR =
	process.env.REACT_APP_HOME_ACTION_BUTTON_COLOR || "#fff";

export const LEAGUE_BUTTON_HOVER =
	process.env.REACT_APP_LEAGUE_BUTTON_HOVER || null;
export const PICK_COLOUR = process.env.REACT_APP_PICK_COLOUR || "#d1ebfd";
export const GAME_NAME = process.env.REACT_APP_GAME_NAME;

export const HEADER_BACKGROUND = process.env.REACT_APP_HEADER_BACKGROUND || "";
export const RADIO_COLOUR = process.env.REACT_APP_RADIO_COLOUR || MAIN_COLOUR;
export const ODDS_BACKGROUND = process.env.REACT_APP_ODDS_BACKGROUND || "";

export const IS_UK = GAME_NAME === "UK";
export const IS_AU = GAME_NAME === "Tabcorp";
export const IS_ES = GAME_NAME === "Spain";
export const IS_MX = GAME_NAME === Syndicates.MX;

export const IS_DE = [Syndicates.DE, Syndicates.DE_RTL].includes(
	GAME_NAME as Syndicates
);
export const IS_RTL = GAME_NAME === "RTL";
export const IS_SPORT_DE_ENABLED = false;

export const ODDS_PARTNER_KEY = process.env.REACT_APP_ODDS_PARTNER_KEY || "";

export const PICKS_STORAGE_KEY = "picks";

export const FB_ID = process.env.REACT_APP_FACEBOOK_APP_ID || "";
export const IS_LOCAL = JSON.parse(process.env.REACT_APP_IS_LOCAL || "false");
export const IS_SKIP_LOCO_LOADING = JSON.parse(
	process.env.REACT_APP_SKIP_LOCO || "false"
);

export const OFF_SEASON_ENABLED = JSON.parse(
	process.env.REACT_APP_OFF_SEASON || "false"
);

const OIDC_URL_PARAM = new URLSearchParams(window.location.search).get("oidc");

const DISABLE_BY_URL = OIDC_URL_PARAM === "true";
export const OIDC_SSO_ENABLED = OIDC_URL_PARAM
	? DISABLE_BY_URL
	: JSON.parse(process.env.REACT_APP_OIDC_SSO || "true");

if (OIDC_URL_PARAM) {
	console.log("OIDC_SSO_ENABLED", OIDC_SSO_ENABLED);
}

export const DEFAULT_STAKE_COEFFICIENT = 1;

export const SPONSOR_URL = process.env.REACT_APP_SPONSOR_URL || "";
